import { render } from "./FeatureSender.vue?vue&type=template&id=36728d0e&scoped=true"
import script from "./FeatureSender.vue?vue&type=script&lang=js"
export * from "./FeatureSender.vue?vue&type=script&lang=js"

import "./FeatureSender.vue?vue&type=style&index=0&id=36728d0e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-36728d0e"

export default script